import { render, staticRenderFns } from "./RecordSongManagerButton.vue?vue&type=template&id=ffef9290&"
import script from "./RecordSongManagerButton.vue?vue&type=script&lang=js&"
export * from "./RecordSongManagerButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports